import { createReducer } from "reduxsauce";
import _ from "lodash";
import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/homework/ArticleActionTypes";
import ArticleService from "../../../services/screens/homework/ArticleService";
import AsyncActionReducers from "../../AsyncActionReducers";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (id, article) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });
            if (id) {
                ArticleService.loadScreenView(
                    id,
                    response => {
                        dispatch(Actions.loadScreenViewSuccess(response));
                    },
                    error => {
                        dispatch(Actions.loadScreenViewFailure(error));
                    }
                );
            } else {
                setTimeout(() => {
                    dispatch(Actions.loadScreenViewSuccess(null, article));
                }, 0);
            }
        };
    },

    loadScreenViewSuccess: (data, article) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        article,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    updateSettings: settings => ({
        type: ActionTypes.UPDATE_SETTINGS,
        settings
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    unitData: null,
    unitType:"",
    id: "",
    settings: {
        pinyinVisible: true,
        translationVisible: true,
        answerVisible: false,
    },
    pinyin: true,
    translation: false,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, article, id }) => {
    return { ...state, id, article, unitData: data ? JSON.parse(data.data || null) : null, unitType:data ? data.unitType : null };
};

const updateSettingsReducer = (state, { settings }) => {
    return { ...state, settings };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_SETTINGS]: updateSettingsReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.homework.article, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
